import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./ProjectCard.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { UserProvider } from "./contextProviders/userContext";
import { StudentProvider } from "./contextProviders/studentContext";
import { ProjectProvider } from "./contextProviders/projectContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UserProvider>
      <ProjectProvider>
        <StudentProvider>
          <App />
        </StudentProvider>
      </ProjectProvider>
    </UserProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
